import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/customers/automations/$id/logs/')({});
